<template>
    <div class="panel">
        <div class="panel_head fx fx-m_between fx-c_start">
            <el-form :inline="true" :model="form">
                <el-form-item label="名称">
                    <el-input v-model="form.keywords" placeholder="关键词"></el-input>
                </el-form-item>
                <el-form-item label="考试" v-if="!attr.examId > 0">
                    <el-select v-model="form.examId" placeholder="考试" :disabled="form.id>0">
                        <el-option v-for="item in exam" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="班级">
                    <el-select v-model="form.classId" filterable clearable placeholder="请选择">
                        <el-option v-for="item in classList" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div>
                <el-link type="warning" @click="loadData"><i class="el-icon-refresh"></i>刷新数据,实时查看学生交卷状态</el-link>
            </div>
        </div>
        <div class="panel_body">
            <el-table :data="tableData" stripe style="width: 100%">
                <el-table-column min-width="100" prop="examStudentNumber" label="考号">
                </el-table-column>
                <el-table-column min-width="150" prop="userName" label="学生名称">
                </el-table-column>
                <el-table-column min-width="180" prop="examName" label="参加考试">
                </el-table-column>
                <el-table-column min-width="200" label="考试时间">
                    <template slot-scope="scope">
                        {{ scope.row.startTime }}-{{ scope.row.endTime }}
                    </template>
                </el-table-column>
                <el-table-column min-width="200" label="规定时长">
                    <template slot-scope="scope">
                        {{ scope.row.examTimeStr }}
                    </template>
                </el-table-column>
                <el-table-column min-width="200" label="实际用时">
                    <template slot-scope="scope">
                        <span v-if="scope.row.state!=3">
                            -
                        </span>
                        <span v-if="scope.row.state==3">
                            <template v-if="scope.row.isTimeout">
                                <font color="red">{{ scope.row.useTimeStr }}(超时)</font>
                            </template>
                            <template v-else>
                                {{ scope.row.useTimeStr }}
                            </template>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column min-width="100" prop="stateName" label="分数">
                    <template slot-scope="scope">
                        <span style="color: red;" v-if="scope.row.state==3">
                            {{scope.row.score}}
                        </span>
                        <span style="color: green;" v-if="scope.row.state!=3">
                            -
                        </span>
                    </template>
                </el-table-column>
                <el-table-column min-width="100" prop="stateName" label="考试状态">
                    <template slot-scope="scope">
                        <span style="color: red;" v-if="scope.row.state==3">
                            {{scope.row.stateName}}
                        </span>
                        <span style="color: green;" v-if="scope.row.state==2">
                            {{scope.row.stateName}}
                        </span>
                        <span style="color:gray;" v-if="scope.row.state==1">
                            {{scope.row.stateName}}
                        </span>
                    </template>
                </el-table-column>
                <!-- <el-table-column
                    min-width="100"
                    prop="score"
                    label="分数构成">
                    <template slot-scope="scope">
                        <div class="fx-col fx-center" style="color:#F56C6C">
                            <span v-if="scope.row.singleQuestion">选择: {{ scope.row.singleScore }}<br/></span>
                            <span v-if="scope.row.blankQuestion">填空: {{ scope.row.blanksScore }}<br/></span>
                            <span v-if="scope.row.operationQuestion">操作: {{ scope.row.operationScore }}<br/></span>
                            <span v-if="scope.row.judgmentQuestion">判断: {{ scope.row.judgmentScore }}</span>
                        </div>
                    </template>
                </el-table-column> -->
                <el-table-column label="操作" width="280">
                    <template slot-scope="scope">
                        <!-- <el-link type="primary" @click="toExam(scope.row)"
                                 :underline="false"><i class="iconfont icon-wenjian font20"></i><b>查看阅卷</b>
                        </el-link> -->
                        <span v-if="scope.row.state!=3">-</span>
                        <el-link v-if="scope.row.state==3" @click="updateState(scope.row)" :underline="false"
                            type="danger">
                            <i class="el-icon-refresh-left"></i><b style="color: #F56C6C;">更改状态</b>
                        </el-link>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="panel_foot fx fx-m_end fx-c_center">
            <el-pagination :background="true" prev-text="上一页" next-text="下一页" layout="prev, pager, next"
                :current-page="pager.currentPage" :page-size="pager.pageSize" :total="pager.dataTotal"
                @current-change="pageChange">
            </el-pagination>
        </div>
    </div>
</template>

<style scoped>

</style>

<script>
    import {
        mapMutations
    } from 'vuex';

    export default {
        components: {},
        props: [
            "attr"
        ],
        data() {
            return {
                form: {
                    keywords: "",
                    enable: true,
                    examId: this.attr.examId > 0 ? this.attr.examId : 0,
                },

                pager: {
                    pageSize: 12,
                    dataTotal: 0,
                    currentPage: 1
                },
                tableData: [],
                exam: {},
                classList: [],
            }

        },
        watch: {
            "form": {
                handler: function(newValue) {
                    this.pager.currentPage = 1;
                    this.loadData();
                },
                deep: true
            }
        },

        methods: {
            ...mapMutations(["openTab"]),
            loadData() {
                this.$ajaxPost("/examResult/getAllStudentExamState", {
                    form: this.form,
                    pager: {
                        ...this.pager,
                        dataTotal: 0
                    }
                }, (data) => {
                    //分页不能带offset，否则会影响后台计算最新offset
                    let {
                        offset,
                        ...pager
                    } = data.pager;
                    this.pager = pager;
                    this.tableData = data.result;
                })
            },
            pageChange(page) {
                this.pager.currentPage = page;
                this.loadData();
            },
            // loadExam() {
            //     this.$ajaxGet("/exam/getListOption", (data) => {
            //         this.exam = data.result;
            //         if (this.attr.examId > 0) {
            //             this.form.examId = this.attr.examId;
            //             return;
            //         }
            //         if (data.result.length > 0) {
            //             this.form.examId = this.exam[0].id;
            //         }
            //     })
            // },
            updateState(item) {
                this.$confirm('您确定要让[' + item.userName + '同学]继续进行考试?', '更改考试状态提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$ajaxPost("/examResult/updateExamState", {
                        form: {
                            examId: this.form.examId,
                            studentId: item.studentId
                        }
                    }, (data) => {
                        if (data.success) {
                            this.loadData();
                            this.$message({
                                type: 'success',
                                message: '设置成功!'
                            });
                        }
                    }, (error) => {
                        this.$message.error({
                            message: error.msg
                        });
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },
            // exportResults() {
            //     let examId = this.form.examId;
            //     let classId = this.form.classId;
            //     window.open("/examResult/exportResults/" + examId + "-" + classId + "?token=" + localStorage.getItem(
            //         "token"));
            // },
            initClassSelect() {
                this.$ajaxPost("/exam/getExamClassList/" + this.form.examId, {}, (data) => {
                    if (data && data.result && data.success) {
                        this.classList = data.result;
                    }
                })
            },
        },

        created() {
            this.loadData();
            //this.loadExam();
            this.initClassSelect();
        }

    }
</script>
